import { instance } from "../apiclient";

export class LivePay {
  async createDeepLink(amount, branchID, domain, storeID) {
    const payload = {
      amount,
      branchID,
      domain,
      storeID
    }
    const data = {
      url: "",
      status: false,
      error: ""
    }
    const result = await instance.post("/stripepayment/livenpay", payload);
    if (result.data.Success) {
      data.status = true;
      data.url = result.data.Data;
    } else {
      data.error = result.data.Status.Message || 'Something went wrong! Please try again';
    }
    return data;
  }

  async checkStatus(deeplink, storeID) {
    const result = await instance.post("/stripepayment/liven/status", { deeplink, storeID });
    return result;
  }
}